'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LABELS = undefined;
exports.getIcon = getIcon;

require('./index.css');

var _ExtraHotSvg = require('./FullBg/ExtraHotSvg');

var _ExtraHotSvg2 = _interopRequireDefault(_ExtraHotSvg);

var _GlutenFreeSvg = require('./FullBg/GlutenFreeSvg');

var _GlutenFreeSvg2 = _interopRequireDefault(_GlutenFreeSvg);

var _HotSvg = require('./FullBg/HotSvg');

var _HotSvg2 = _interopRequireDefault(_HotSvg);

var _OrganicSvg = require('./FullBg/OrganicSvg');

var _OrganicSvg2 = _interopRequireDefault(_OrganicSvg);

var _SpicySvg = require('./FullBg/SpicySvg');

var _SpicySvg2 = _interopRequireDefault(_SpicySvg);

var _VeganSvg = require('./FullBg/VeganSvg');

var _VeganSvg2 = _interopRequireDefault(_VeganSvg);

var _VegetarianSvg = require('./FullBg/VegetarianSvg');

var _VegetarianSvg2 = _interopRequireDefault(_VegetarianSvg);

var _ExtraHotSvg3 = require('./Labels/ExtraHotSvg');

var _ExtraHotSvg4 = _interopRequireDefault(_ExtraHotSvg3);

var _GlutenFreeSvg3 = require('./Labels/GlutenFreeSvg');

var _GlutenFreeSvg4 = _interopRequireDefault(_GlutenFreeSvg3);

var _HotSvg3 = require('./Labels/HotSvg');

var _HotSvg4 = _interopRequireDefault(_HotSvg3);

var _OrganicSvg3 = require('./Labels/OrganicSvg');

var _OrganicSvg4 = _interopRequireDefault(_OrganicSvg3);

var _SpicySvg3 = require('./Labels/SpicySvg');

var _SpicySvg4 = _interopRequireDefault(_SpicySvg3);

var _VeganSvg3 = require('./Labels/VeganSvg');

var _VeganSvg4 = _interopRequireDefault(_VeganSvg3);

var _VegetarianSvg3 = require('./Labels/VegetarianSvg');

var _VegetarianSvg4 = _interopRequireDefault(_VegetarianSvg3);

var _ExtraHotSvg5 = require('./Full/ExtraHotSvg');

var _ExtraHotSvg6 = _interopRequireDefault(_ExtraHotSvg5);

var _GlutenFreeSvg5 = require('./Full/GlutenFreeSvg');

var _GlutenFreeSvg6 = _interopRequireDefault(_GlutenFreeSvg5);

var _HotSvg5 = require('./Full/HotSvg');

var _HotSvg6 = _interopRequireDefault(_HotSvg5);

var _OrganicSvg5 = require('./Full/OrganicSvg');

var _OrganicSvg6 = _interopRequireDefault(_OrganicSvg5);

var _SpicySvg5 = require('./Full/SpicySvg');

var _SpicySvg6 = _interopRequireDefault(_SpicySvg5);

var _VeganSvg5 = require('./Full/VeganSvg');

var _VeganSvg6 = _interopRequireDefault(_VeganSvg5);

var _VegetarianSvg5 = require('./Full/VegetarianSvg');

var _VegetarianSvg6 = _interopRequireDefault(_VegetarianSvg5);

var _ExtraHotSvg7 = require('./Outline/ExtraHotSvg');

var _ExtraHotSvg8 = _interopRequireDefault(_ExtraHotSvg7);

var _GlutenFreeSvg7 = require('./Outline/GlutenFreeSvg');

var _GlutenFreeSvg8 = _interopRequireDefault(_GlutenFreeSvg7);

var _HotSvg7 = require('./Outline/HotSvg');

var _HotSvg8 = _interopRequireDefault(_HotSvg7);

var _OrganicSvg7 = require('./Outline/OrganicSvg');

var _OrganicSvg8 = _interopRequireDefault(_OrganicSvg7);

var _SpicySvg7 = require('./Outline/SpicySvg');

var _SpicySvg8 = _interopRequireDefault(_SpicySvg7);

var _VeganSvg7 = require('./Outline/VeganSvg');

var _VeganSvg8 = _interopRequireDefault(_VeganSvg7);

var _VegetarianSvg7 = require('./Outline/VegetarianSvg');

var _VegetarianSvg8 = _interopRequireDefault(_VegetarianSvg7);

var _AllIcons = require('./AllIcons');

var _AllIcons2 = _interopRequireDefault(_AllIcons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
    'full-bg-vegan': _VeganSvg2.default,
    'full-bg-vegetarian': _VegetarianSvg2.default,
    'full-bg-spicy1': _SpicySvg2.default,
    'full-bg-spicy2': _HotSvg2.default,
    'full-bg-spicy3': _ExtraHotSvg2.default,
    'full-bg-gluten-free': _GlutenFreeSvg2.default,
    'full-bg-organic': _OrganicSvg2.default,

    'full-vegan': _VeganSvg6.default,
    'full-vegetarian': _VegetarianSvg6.default,
    'full-spicy1': _SpicySvg6.default,
    'full-spicy2': _HotSvg6.default,
    'full-spicy3': _ExtraHotSvg6.default,
    'full-gluten-free': _GlutenFreeSvg6.default,
    'full-organic': _OrganicSvg6.default,

    'outline-vegan': _VeganSvg8.default,
    'outline-vegetarian': _VegetarianSvg8.default,
    'outline-spicy1': _SpicySvg8.default,
    'outline-spicy2': _HotSvg8.default,
    'outline-spicy3': _ExtraHotSvg8.default,
    'outline-gluten-free': _GlutenFreeSvg8.default,
    'outline-organic': _OrganicSvg8.default,

    'label-vegan': _VeganSvg4.default,
    'label-vegetarian': _VegetarianSvg4.default,
    'label-spicy1': _SpicySvg4.default,
    'label-spicy2': _HotSvg4.default,
    'label-spicy3': _ExtraHotSvg4.default,
    'label-gluten-free': _GlutenFreeSvg4.default,
    'label-organic': _OrganicSvg4.default
};

var LABELS = exports.LABELS = ['spicy1', 'spicy2', 'spicy3', 'organic', 'vegetarian', 'vegan', 'gluten-free'];

function getIcon(iconType, label) {
    return components[iconType + '-' + label];
}

exports.default = {
    FullBgExtraHotSvg: _ExtraHotSvg2.default,
    FullBgGlutenFreeSvg: _GlutenFreeSvg2.default,
    FullBgHotSvg: _HotSvg2.default,
    FullBgOrganicSvg: _OrganicSvg2.default,
    FullBgSpicySvg: _SpicySvg2.default,
    FullBgVeganSvg: _VeganSvg2.default,
    FullBgVegetarianSvg: _VegetarianSvg2.default,
    LabelExtraHotSvg: _ExtraHotSvg4.default,
    LabelGlutenFreeSvg: _GlutenFreeSvg4.default,
    LabelHotSvg: _HotSvg4.default,
    LabelOrganicSvg: _OrganicSvg4.default,
    LabelSpicySvg: _SpicySvg4.default,
    LabelVeganSvg: _VeganSvg4.default,
    LabelVegetarianSvg: _VegetarianSvg4.default,
    FullExtraHotSvg: _ExtraHotSvg6.default,
    FullGlutenFreeSvg: _GlutenFreeSvg6.default,
    FullHotSvg: _HotSvg6.default,
    FullOrganicSvg: _OrganicSvg6.default,
    FullSpicySvg: _SpicySvg6.default,
    FullVeganSvg: _VeganSvg6.default,
    FullVegetarianSvg: _VegetarianSvg6.default,
    OutlineExtraHotSvg: _ExtraHotSvg8.default,
    OutlineGlutenFreeSvg: _GlutenFreeSvg8.default,
    OutlineHotSvg: _HotSvg8.default,
    OutlineOrganicSvg: _OrganicSvg8.default,
    OutlineSpicySvg: _SpicySvg8.default,
    OutlineVeganSvg: _VeganSvg8.default,
    OutlineVegetarianSvg: _VegetarianSvg8.default,
    getIcon: getIcon,
    AllIcons: _AllIcons2.default,
    LABELS: LABELS
};